import React from 'react'

const ContactUs = () => {
  return (
    <div className='grid gap-8 pt-12 pb-10 px-10' id='contact-us'>
        <div className='grid justify-items-center gap-2'>
            <h1 className='text-5xl text-[#006DC4] font-semibold'>Contactez-nous !</h1>
            <p className='gabriel text-yellow-500 uppercase text-xl'>Notre equipe est toujours à L'écoute</p>
        </div>
        <div className='flex items-center space-x-20'>
            <div>
            <iframe title="AEDS suliman" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d25591.44634511172!2d10.453622724483164!3d36.700200909961666!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12fd50fc65018c39%3A0x9faf07869d445c0a!2sSoliman!5e0!3m2!1sfr!2stn!4v1726584785067!5m2!1sfr!2stn" width="600" height="450"  allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div>
            <div className='grid gap-12 w-1/2'>
                <input type='text' placeholder='Nom & Prénom' className=' border-b-[1px] border-[#006DC4]'  />
                <div className='flex space-x-4 w-full'>
                    <input type="email" placeholder='E-mail' className='border-b-[1px] w-full border-[#006DC4]' />
                    <input type="tel" placeholder='Numéro mobile' className='border-b-[1px] w-full border-[#006DC4]' />
                </div>
                <textarea type='text' placeholder='Message' className='border-b-[1px] border-[#006DC4]' />
                <div>
                    <button className='px-3 py-2 text-white font-semibold bg-[#006DC4]'>Envoyez votre message</button>
                </div>
            </div>
        </div>

    </div>
  )
}

export default ContactUs